import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledDescription = styled.div`
  .mobile-product-options-container {
    display: none;
  }

  .show-toggle {
    color: ${(props) => props.theme.brand02};
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    margin-left: 5px;
    text-decoration: underline;
    white-space: nowrap;
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    font-size: 1rem;
  }

  @media only screen and (max-width: ${breakpoints.xs}px) {
    .mobile-product-options-container {
      display: flex;
      margin-top: 8px;
      flex-wrap: wrap;
      .mobile-product-option-tag {
        background-color: transparent;
        color: ${(props) => props.theme.black};
        border-radius: 40px;
        border: 1px solid ${(props) => props.theme.tagBorderColor};
        padding: 3px 6px;
        font-family: ${(props) => props.theme.fontText};
        margin-bottom: 8px;
      }
    }
  }
`;
